import HttpHeader from 'src/Admin/shared/httpheader';
import { USE_PERSONA_FRAMEWORK } from 'src/constants';
import domainResources from 'src/Admin/configuration/apiDomain.json';

class APIEndpoints {
  constructor() {
    this.userListResources = '';
    this.userListDetailsResources = '';
    this.eligibilityRules = '';
    this.userRolesResources = '';
    this.BLOBListResources = '';
    this.BlobRangeResources = '';
    this.EmployerListResources = '';
    this.LocationListResources = '';
    this.RoleListResources = '';
    this.UserListWithRoleResorces = '';
    this.RoleAffliationwWithRoleResorces = '';
    this.RoleAffliationwWithUserTypeResorces = '';
    this.UpdateRolePermissionAffliationResources = '';
    this.AddRolePermissionAffliationResources = '';
    this.createUserAPIResource = '';
    this.createUserRoleAPIResource = '';
    this.userIDCheckAPIResource = '';
    this.updateUserAPIResource = '';
    this.updateProviderSelfRegistration = '';
    this.apiDomain = '';
    this.loginResource = '';
    this.memberSummaryResource = '';
    this.memberCoverageSummaryResource = '';
    this.memberextcoveragesummary = '';
    this.memberAccumulatorResource = '';
    this.memberCoverageAccumsResource = '';
    this.claimStatusSummaryReource = '';
    this.claimStatusSummaryByProductResource = '';
    this.spendingSummaryResource = '';
    this.claimsListResource = '';
    this.claimslistFamilyTabsResource = '';
    this.claimDetailsResource = '';
    this.coveredServicesCostResource = '';
    this.myProfileDetailsResource = '';
    this.accountDetailsResource = '';
    this.sendEmailResource = '';
    this.getMember = '';
    this.getIdCard = '';
    this.getuserIdCard = '';
    this.EOB = '';
    this.GET_ECHO_EOB = '';
    this.contactInfo = '';
    this.searchContactInfo = '';
    this.page = '';
    this.pages = '';
    this.link = '';
    this.rules = '';
    this.links = '';
    this.searchLinks = '';
    this.postDocument = '';
    this.medias = '';
    this.resource = '';
    this.searchResources = '';
    this.getAccumsData = '';
    this.helpDocuments = '';
    //admin
    this.getAdminConfig = '';
    this.putAdminConfig = '';
    this.postAdminConfig = '';
    this.putResetUser = '';
    this.postResetUser = '';
    this.putResetPwd = '';
    this.postResetPwd = '';
    this.searchBlockOfBusiness = '';
    this.deleteAdminConfig = '';
    this.logoutResource = '';
    this.getOtpGenerate = '';
    this.getOtpVerify = '';
    this.registeredMemberListResources = '';
    this.unregisteredMemberListResources = '';
    //client
    this.getClientConfig = '';
    this.putClientConfig = '';
    this.postClientConfig = '';
    this.encryptionKey = '';
    this.BrokersLists = '';
    this.PermissionGroupLists = '';
    this.SecurityQuestions = '';
    this.createAllUserTypesAPIResource = '';
    this.SecurityQuestionsUserID = '';
    this.ValidateSecurityQuestions = '';
    this.getUserRegistionDetails = '';
    this.getUserDetails = '';
    this.postSecQuestions = '';
    this.updateAllUserAPIResource = '';
    this.sendResetPasswordMail = '';
    this.verifyResetPasswordLink = '';
    this.resendRegistrationEmailResources = '';
    this.getAllReportListResource = '';
    this.getReportsCategoryAndNameResource = '';
    this.getReportDynamicFieldsResource = '';
    this.generateReportResource = '';
    this.getViewMemberinformationResource = '';
    this.getFacilityListsResource = '';
    this.getDoctorsListsResource = '';
    this.getHippaPermissionsResource = '';
    this.getPublishedMessageResource = '';
    this.allEmrollmentConfigList = '';
    this.enrollmentAddDependentAddressDetails = '';
  }

  getAPIDomain() {
    this.apiDomain = `https://${HttpHeader.getCNAME()}.${HttpHeader.getDomainName()}/apigw/v1`;
    //this.apiDomain = 'https://centivo-test.mphasishealthportal.com/apigw/v1';
    return this.apiDomain;
  }

  getAdminConfigResources() {
    domainResources.map((domainResource) => {
      this.getAdminConfig = domainResource.GET_ADMIN_CONFIG_RESOURCE;
      return;
    });
    return this.getAPIDomain() + this.getAdminConfig;
  }
  putAdminConfigResources() {
    domainResources.map((domainResource) => {
      this.putAdminConfig = domainResource.PUT_ADMIN_CONFIG_RESOURCE;
      return;
    });
    return this.getAPIDomain() + this.putAdminConfig;
  }
  postAdminConfigResources() {
    domainResources.map((domainResource) => {
      this.postAdminConfig = domainResource.POST_ADMIN_CONFIG_RESOURCE;
      return;
    });
    return this.getAPIDomain() + this.postAdminConfig;
  }

  updateResetEmailResources() {
    domainResources.map((domainResource) => {
      this.putResetUser = domainResource.UPDATE_RESET_EMAIL_RESOURCE;
      return;
    });
    return this.getAPIDomain() + this.putResetUser;
  }

  addResetEmailResources() {
    domainResources.map((domainResource) => {
      this.postResetUser = domainResource.ADD_RESET_EMAIL_RESOURCE;
      return;
    });
    return this.getAPIDomain() + this.postResetUser;
  }

  updateResetPasswordResources() {
    domainResources.map((domainResource) => {
      this.putResetPwd = domainResource.UPDATE_RESET_PASSWORD_RESOURCE;
      return;
    });
    return this.getAPIDomain() + this.putResetPwd;
  }

  addResetPasswordResources() {
    domainResources.map((domainResource) => {
      this.postResetPwd = domainResource.ADD_RESET_PASSWORD_RESOURCE;
      return;
    });
    return this.getAPIDomain() + this.postResetPwd;
  }

  deleteAdminConfigResources() {
    domainResources.map((domainResource) => {
      this.deleteAdminConfig = domainResource.DELETE_ADMIN_CONFIG_RESOURCE;
      return;
    });
    return this.getAPIDomain() + this.deleteAdminConfig;
  }

  getUserListDetailsResources() {
    domainResources.map((domainResource) => {
      if (USE_PERSONA_FRAMEWORK) {
        this.userListDetailsResources = domainResource.GET_USER_FOR_ALL_TYPES;
      } else {
        this.userListDetailsResources =
          domainResource.USER_LIST_DETAILS_RESOURCE;
      }
      return;
    });
    return this.getAPIDomain() + this.userListDetailsResources;
  }

  getUserRolesResources() {
    domainResources.map((domainResource) => {
      this.userRolesResources = domainResource.GET_USER_ROLES_RESOURCE;
      return;
    });
    return this.getAPIDomain() + this.userRolesResources;
  }

  GetUser() {
    domainResources.map((domainResource) => {
      if (USE_PERSONA_FRAMEWORK) {
        this.getUser = domainResource.GET_USER_FOR_ALL_TYPES;
      } else {
        this.getUser = domainResource.GET_USER;
      }
      return;
    });
    return this.getAPIDomain() + this.getUser;
  }

  GetMember() {
    domainResources.map((domainResource) => {
      this.getMember = domainResource.GET_MEMBER;
      return;
    });
    return this.getAPIDomain() + this.getMember;
  }

  GetMemberIdCard() {
    domainResources.map((domainResource) => {
      this.getIdCard = domainResource.GET_ID_CARD;
      return;
    });
    return this.getAPIDomain() + this.getIdCard;
  }

  GetMemberIdCardPdf() {
    domainResources.map((domainResource) => {
      this.getIdCardPdf = domainResource.GET_ID_CARD_PDF;
      return;
    });
    return this.getAPIDomain() + this.getIdCardPdf;
  }

  GetMemberIdCardPdfEcho() {
    return this.getAPIDomain() + domainResources.GET_ECHO_ID_CARD_PDF;
  }

  getRequestedIDCard() {
    domainResources.map((domainResource) => {
      this.getuserIdCard = domainResource.GET_USER_ID_CARD;
      return;
    });
    return this.getAPIDomain() + this.getuserIdCard;
  }
  //Admin Blob

  getBLOBListResources() {
    domainResources.map((domainResource) => {
      this.BLOBListResources = domainResource.BLOB_LIST_RESOURCE;
      return;
    });
    return this.getAPIDomain() + this.BLOBListResources;
  }
  getBlobRangeResources() {
    domainResources.map((domainResource) => {
      this.BlobRangeResources = domainResource.BLOB_RANGE_RESOURCE;
      return;
    });
    return this.getAPIDomain() + this.BlobRangeResources;
  }
  getEmployerListResources() {
    domainResources.map((domainResource) => {
      this.EmployerListResources = domainResource.EMPLOYER_LIST_RESOURCE;
      return;
    });
    return this.getAPIDomain() + this.EmployerListResources;
  }
  getLocationListResources() {
    domainResources.map((domainResource) => {
      this.LocationListResources = domainResource.LOCATION_LIST_RESOURCE;
      return;
    });
    return this.getAPIDomain() + this.LocationListResources;
  }
  getRoleListResources() {
    domainResources.map((domainResource) => {
      this.RoleListResources = domainResource.ROLE_LIST_RESOURCE;
      return;
    });
    return this.getAPIDomain() + this.RoleListResources;
  }
  getUserListWithRoleResorces() {
    domainResources.map((domainResource) => {
      this.UserListWithRoleResorces =
        domainResource.USER_LIST_WITH_ROLE_RESOURCE;
      return;
    });
    return this.getAPIDomain() + this.UserListWithRoleResorces;
  }
  getRoleAffliationwWithRoleResorces() {
    domainResources.map((domainResource) => {
      this.RoleAffliationwWithRoleResorces =
        domainResource.ROLE_AFFLI_WITH_ROLE_RESOURCE;
      return;
    });
    return this.getAPIDomain() + this.RoleAffliationwWithRoleResorces;
  }

  getRoleAffliationwWithUserTypeResorces() {
    domainResources.map((domainResource) => {
      this.RoleAffliationwWithUserTypeResorces =
        domainResource.ROLE_AFFLI_WITH_USERTYPE_RESOURCE;
      return;
    });
    return this.getAPIDomain() + this.RoleAffliationwWithUserTypeResorces;
  }

  updateRolePermissionAffliationwResources() {
    domainResources.map((domainResource) => {
      this.UpdateRolePermissionAffliationResources =
        domainResource.UPDATE_ROLE_PERMISSION_AFFLI_RESOURCE;
      return;
    });
    return this.getAPIDomain() + this.UpdateRolePermissionAffliationResources;
  }

  addRolePermissionAffliationwResources() {
    domainResources.map((domainResource) => {
      this.AddRolePermissionAffliationResources =
        domainResource.ADD_ROLE_PERMISSION_AFFLI_RESOURCE;
      return;
    });
    return this.getAPIDomain() + this.AddRolePermissionAffliationResources;
  }

  getUserListResources() {
    domainResources.map((domainResource) => {
      this.userListResources = domainResource.USER_LIST_RESOURCE;
      return;
    });
    return this.getAPIDomain() + this.userListResources;
  }
  getEligibilityRulesAndNotifications() {
    domainResources.map((domainResource) => {
      this.eligibilityRules = domainResource.ELIGIBILITY_RULES_NOTIFICATIONS;
      return;
    });
    return this.getAPIDomain() + this.eligibilityRules;
  }
  getRegisterdMemberListResources() {
    domainResources.map((domainResource) => {
      this.registeredMemberListResources =
        domainResource.REGISTERED_MEMBER_LIST;
      return;
    });
    return this.getAPIDomain() + this.registeredMemberListResources;
  }

  getAllMemberListResources() {
    domainResources.map((domainResource) => {
      this.unregisteredMemberListResources =
        domainResource.UNREGISTERED_MEMBER_LIST;
      return;
    });
    return this.getAPIDomain() + this.unregisteredMemberListResources;
  }

  getCreateUserAPIResource() {
    domainResources.map((domainResource) => {
      this.createUserAPIResource = domainResource.CREATE_USER_API_RESOURCE;
      return;
    });
    return this.getAPIDomain() + this.createUserAPIResource;
  }
  getUpdateUserAPIResource() {
    domainResources.map((domainResource) => {
      this.updateUserAPIResource = domainResource.UPDATE_USER_API_RESOURCE;
      return;
    });
    return this.getAPIDomain() + this.updateUserAPIResource;
  }
  updateUserProviderSelfRegistration() {
    domainResources.map((domainResource) => {
      this.updateProviderSelfRegistration =
        domainResource.UPDATE_PROVIDER_SELF_REGISTRATION;
      return;
    });
    return this.getAPIDomain() + this.updateProviderSelfRegistration;
  }

  getCreateUserRoleAPIResource() {
    domainResources.map((domainResource) => {
      this.createUserRoleAPIResource =
        domainResource.CREATE_USER_ROLE_API_RESOURCE;
      return;
    });
    return this.getAPIDomain() + this.createUserRoleAPIResource;
  }

  getUpdateUserRoleAPIResource() {
    domainResources.map((domainResource) => {
      this.updateUserRoleAPIResource =
        domainResource.UPDATE_USER_ROLE_API_RESOURCE;
      return;
    });
    return this.getAPIDomain() + this.updateUserRoleAPIResource;
  }

  getUserIDCheckAPIResource() {
    domainResources.map((domainResource) => {
      this.userIDCheckAPIResource = domainResource.USER_ID_CHECK_API_RESOURCE;
      return;
    });
    return this.getAPIDomain() + this.userIDCheckAPIResource;
  }
  getLoginResource() {
    domainResources.map((domainResource) => {
      this.loginResource = domainResource.LOGIN_RESOURCE;
      return;
    });
    return this.getAPIDomain() + this.loginResource;
  }

  getMemberSummaryResource() {
    domainResources.map((domainResource) => {
      this.memberSummaryResource = domainResource.MEMBER_SUMMARY_RESOURCE;
      return;
    });
    return this.getAPIDomain() + this.memberSummaryResource;
  }

  getMemberCoverageSummaryResource() {
    domainResources.map((domainResource) => {
      this.memberCoverageSummaryResource =
        domainResource.MEMBER_COVERAGE_SUMMARY_RESOURCE;
      return;
    });
    return this.getAPIDomain() + this.memberCoverageSummaryResource;
  }
  getMemberExtCoverageSummaryResource() {
    domainResources.map((domainResource) => {
      this.memberExtCoverageSummary =
        domainResource.MEMBER_EXTCOVERAGE_SUMMARY_RESOURCE;
      return;
    });
    return this.getAPIDomain() + this.memberExtCoverageSummary;
  }
  //get benefits availed details
  getBenefitsAvailed() {
    domainResources.map((domainResource) => {
      this.benefitsAvailed = domainResource.BENEFITS_AVAILED;
      return;
    });
    return this.getAPIDomain() + this.benefitsAvailed;
  }

  getMemberCoveragePlan() {
    domainResources.map((domainResource) => {
      this.memberCoveragePlan = domainResource.MEMBER_COVERAGE_PLAN;
      return;
    });
    return this.getAPIDomain() + this.memberCoveragePlan;
  }
  getMemberCoveredServices() {
    domainResources.map((domainResource) => {
      this.memberCoveredServices = domainResource.MEMBER_COVERED_SERVICES;
      return;
    });
    return this.getAPIDomain() + this.memberCoveredServices;
  }
  getMemberAccumulatorResource() {
    domainResources.map((domainResource) => {
      this.memberAccumulatorResource =
        domainResource.MEMBER_ACCUMULATOR_RESOURCE;
      return;
    });
    return this.getAPIDomain() + this.memberAccumulatorResource;
  }

  getMemberCoverageAccumsResource() {
    domainResources.map((domainResource) => {
      this.memberCoverageAccumsResource =
        domainResource.MEMBER_COVERAGE_ACCUMS_RESOURCE;
      return;
    });
    return this.getAPIDomain() + this.memberCoverageAccumsResource;
  }

  getClaimStatusSummaryReource() {
    domainResources.map((domainResource) => {
      this.claimStatusSummaryReource =
        domainResource.CLAIM_STATUS_SUMMARY_RESOURCE;
      return;
    });
    return this.getAPIDomain() + this.claimStatusSummaryReource;
  }

  getClaimStatusSummaryByProductResource() {
    domainResources.map((domainResource) => {
      this.claimStatusSummaryByProductResource =
        domainResource.CLAIM_STATUS_SUMMARY_BY_PRODUCT_RESOURCE;
      return;
    });
    return this.getAPIDomain() + this.claimStatusSummaryByProductResource;
  }

  getSpendingSummaryResource() {
    domainResources.map((domainResource) => {
      this.spendingSummaryResource = domainResource.SPENDING_SUMMARY_RESOURCE;
      return;
    });
    return this.getAPIDomain() + this.spendingSummaryResource;
  }

  getClaimsListResource() {
    domainResources.map((domainResource) => {
      this.claimsListResource = domainResource.CLAIMS_LIST;
      return;
    });
    return this.getAPIDomain() + this.claimsListResource;
  }

  getClaimslistFamilyTabsResource() {
    domainResources.map((domainResource) => {
      this.claimslistFamilyTabsResource = domainResource.CLAIMLIST_FAMILY_TABS;
      return;
    });
    return this.getAPIDomain() + this.claimslistFamilyTabsResource;
  }

  getClaimDetailsResource() {
    domainResources.map((domainResource) => {
      this.claimDetailsResource = domainResource.CLAIM_DETAILS;
      return;
    });
    return this.getAPIDomain() + this.claimDetailsResource;
  }
  getAdditionalPaymentDetailsResource() {
    domainResources.map((domainResource) => {
      this.claimAdditioanlPaymentDetailsResource =
        domainResource.CLAIM_ADDITIOANL_PAYMENT_DETAILS;
      return;
    });
    return this.getAPIDomain() + this.claimAdditioanlPaymentDetailsResource;
  }

  getClaimAttributeDescription() {
    domainResources.map((domainResource) => {
      this.claimAttributeDescription =
        domainResource.GET_CLAIM_ATTRIBUTE_DESCRIPTION;
      return;
    });
    return this.getAPIDomain() + this.claimAttributeDescription;
  }
  getClaimAttributeDescriptionAdjustment() {
    domainResources.map((domainResource) => {
      this.claimAttributeDescriptionAdjustment =
        domainResource.GET_CLAIM_ATTRIBUTE_DESCRIPTION_ADJUSTMENT;
      return;
    });
    return this.getAPIDomain() + this.claimAttributeDescriptionAdjustment;
  }
  getEligibilityRelationshipNames() {
    domainResources.map((domainResource) => {
      this.enrollmentRelationshipNames =
        domainResource.GET_RULES_RELATIONSHIP_NAMES;
      return;
    });
    return this.getAPIDomain() + this.enrollmentRelationshipNames;
  }
  getCoveredServicesCostResource() {
    domainResources.map((domainResource) => {
      this.coveredServicesCostResource = domainResource.COVERED_SERVICES_COST;
      return;
    });
    return this.getAPIDomain() + this.coveredServicesCostResource;
  }

  getMyProfileDetailsResource() {
    domainResources.map((domainResource) => {
      this.myProfileDetailsResource = domainResource.MY_PROFILE_DETAILS;
      return;
    });
    return this.getAPIDomain() + this.myProfileDetailsResource;
  }

  getAccountDetailsResource() {
    domainResources.map((domainResource) => {
      this.accountDetailsResource = domainResource.ACCOUNT_DETAILS;
      return;
    });
    return this.getAPIDomain() + this.accountDetailsResource;
  }

  getSendEmailResource() {
    domainResources.map((domainResource) => {
      this.sendEmailResource = domainResource.EMAIL_SEND;
      return;
    });
    return this.getAPIDomain() + this.sendEmailResource;
  }

  getLogoutResource() {
    domainResources.map((domainResource) => {
      this.logoutResource = domainResource.LOGOUT_RESOURCE;
      return;
    });
    return this.getAPIDomain() + this.logoutResource;
  }

  getOtpGenerateResources() {
    domainResources.map((domainResource) => {
      this.getOtpGenerate = domainResource.OTP_GENERATE_RESOURCE;
      return;
    });
    return this.getAPIDomain() + this.getOtpGenerate;
  }

  getOtpVerifyResources() {
    domainResources.map((domainResource) => {
      this.getOtpVerify = domainResource.OTP_VALIDATE_RESOURCE;
      return;
    });
    return this.getAPIDomain() + this.getOtpVerify;
  }

  getPlanYearPeriod() {
    domainResources.map((domainResource) => {
      this.planYearPeriod = domainResource.PLAN_YEAR_PERIOD;
      return;
    });
    return this.getAPIDomain() + this.planYearPeriod;
  }

  getKeyStoreResources() {
    domainResources.map((domainResource) => {
      this.getKeyStore = domainResource.GET_KEY_STORE_RESOURCE;
      return;
    });
    return this.getAPIDomain() + this.getKeyStore;
  }

  getEncryptionKeyResources() {
    domainResources.map((domainResource) => {
      this.encryptionKey = domainResource.GET_ENCRYPTION_KEY_RESOURCE;
      return;
    });
    return this.getAPIDomain() + this.encryptionKey;
  }

  getClientConfigResources() {
    domainResources.map((domainResource) => {
      this.getClientConfig = domainResource.GET_CLIENT_CONFIG_RESOURCE;
      return;
    });
    return this.getAPIDomain() + this.getClientConfig;
  }
  putClientConfigResources() {
    domainResources.map((domainResource) => {
      this.putClientConfig = domainResource.PUT_CLIENT_CONFIG_RESOURCE;
      return;
    });
    return this.getAPIDomain() + this.putClientConfig;
  }
  postClientConfigResources() {
    domainResources.map((domainResource) => {
      this.postClientConfig = domainResource.POST_CLIENT_CONFIG_RESOURCE;
      return;
    });
    return this.getAPIDomain() + this.postClientConfig;
  }
  getEOB() {
    domainResources.map((domainResource) => {
      this.EOB = domainResource.GET_EOB;
      return;
    });
    return this.getAPIDomain() + this.EOB;
  }

  getEchoEOB() {
    domainResources.map((domainResource) => {
      this.GET_ECHO_EOB = domainResource.GET_ECHO_EOB;
      return;
    });
    return this.getAPIDomain() + this.GET_ECHO_EOB;
  }

  contactInfoResource() {
    domainResources.map((domainResource) => {
      this.contactInfo = domainResource.CONTACT_INFO;
      return;
    });
    return this.getAPIDomain() + this.contactInfo;
  }

  searchContactInfoResource() {
    domainResources.map((domainResource) => {
      this.searchContactInfo = domainResource.SEARCH_CONTACT_INFO;
      return;
    });
    return this.getAPIDomain() + this.searchContactInfo;
  }

  getSocialMediaLinks() {
    domainResources.map((domainResource) => {
      this.medias = domainResource.GET_SOCIAL_MEDIA_LINKS;
      return;
    });
    return this.getAPIDomain() + this.medias;
  }

  pageResource() {
    domainResources.map((domainResource) => {
      this.page = domainResource.PAGE_RESOURCE;
      return;
    });
    return this.getAPIDomain() + this.page;
  }
  pagesResource() {
    domainResources.map((domainResource) => {
      this.pages = domainResource.PAGES_RESOURCE;
      return;
    });
    return this.getAPIDomain() + this.pages;
  }

  linkResource() {
    domainResources.map((domainResource) => {
      this.link = domainResource.LINK;
      return;
    });
    return this.getAPIDomain() + this.link;
  }
  saveRulesAndNotifications() {
    domainResources.map((domainResource) => {
      this.rules = domainResource.SAVE_RULES_NOTIFICATIONS;
      return;
    });
    return this.getAPIDomain() + this.rules;
  }
  linksResource() {
    domainResources.map((domainResource) => {
      this.links = domainResource.LINKS;
      return;
    });
    return this.getAPIDomain() + this.links;
  }

  searchLinksResource() {
    domainResources.map((domainResource) => {
      this.searchLinks = domainResource.SEARCH_LINKS;
      return;
    });
    return this.getAPIDomain() + this.searchLinks;
  }
  postDocumentResource() {
    domainResources.map((domainResource) => {
      this.postDocument = domainResource.POST_DOCUMENT;
      return;
    });
    return this.getAPIDomain() + this.postDocument;
  }
  getDocument() {
    domainResources.map((domainResource) => {
      this.GET_DOCUMENT = domainResource.GET_DOCUMENT;
      return;
    });
    return this.getAPIDomain() + this.GET_DOCUMENT;
  }
  resourceResource() {
    domainResources.map((domainResource) => {
      this.resource = domainResource.RESOURCE;
      return;
    });
    return this.getAPIDomain() + this.resource;
  }
  searchResourceResource() {
    domainResources.map((domainResource) => {
      this.searchResources = domainResource.SEARCH_RESOURCES;
      return;
    });
    return this.getAPIDomain() + this.searchResources;
  }
  getAccumulatorDataResource() {
    domainResources.map((domainResource) => {
      this.getAccumsData = domainResource.ACCUMS_RESOURCE;
      return;
    });
    return this.getAPIDomain() + this.getAccumsData;
  }
  getAllHelpCenterDocuments() {
    domainResources.map((domainResource) => {
      this.helpDocuments = domainResource.HELPCENTER_DOCUMENTS;
      return;
    });
    return this.getAPIDomain() + this.helpDocuments;
  }
  getResourceOptions() {
    domainResources.map((domainResource) => {
      this.searchResources = domainResource.SEARCH_RESOURCES;
      return;
    });
    return this.getAPIDomain() + this.searchResources + '/resourcegroup/true';
  }

  getProducts() {
    domainResources.map((domainResource) => {
      this.Products = domainResource.GET_PRODUCTS;
      return;
    });

    return this.getAPIDomain() + this.Products;
  }

  getPlans() {
    domainResources.map((domainResource) => {
      this.Plans = domainResource.GET_PLANS;
      return;
    });

    return this.getAPIDomain() + this.Plans;
  }

  getAppConfigs() {
    domainResources.map((domainResource) => {
      this.appConfigs = domainResource.GET_APP_CONFIGS;
      return;
    });

    return this.getAPIDomain() + this.appConfigs;
  }

  getAppDefinations() {
    domainResources.map((domainResource) => {
      this.appDefinations = domainResource.GET_APP_DEFINATIONS;
      return;
    });

    return this.getAPIDomain() + this.appDefinations;
  }

  getCustomNetworkList() {
    domainResources.map((domainResource) => {
      this.customNetworkList = domainResource.GET_CUSTOM_NETWORK_LIST;
      return;
    });

    return this.getAPIDomain() + this.customNetworkList;
  }

  getReportConfigs() {
    domainResources.map((domainResource) => {
      this.reportConfigs = domainResource.GET_APP_REPORT_CONFIG;
      return;
    });

    return this.getAPIDomain() + this.reportConfigs;
  }

  getAllNetworkList() {
    domainResources.map((domainResource) => {
      this.allNetworkList = domainResource.GET_ALL_NETWORK_LIST;
      return;
    });

    return this.getAPIDomain() + this.allNetworkList;
  }

  getAllClaimLabelsLIst() {
    return this.getAPIDomain() + domainResources[0].GET_ALL_CLAIM_LABELS_LIST;
  }

  updateStatusLabels() {
    return (
      this.getAPIDomain() + domainResources[0].UPDATE_ALL_CLAIM_LABELS_LIST
    );
  }

  putUpdateConfiguration() {
    domainResources.map((domainResource) => {
      this.updateConfiguration = domainResource.UPDATE_CONFIGS;
      return;
    });

    return this.getAPIDomain() + this.updateConfiguration;
  }

  syncReportConfigration() {
    domainResources.map((domainResource) => {
      this.syncReport = domainResource.SYNC_CONFIGS;
      return;
    });

    return this.getAPIDomain() + this.syncReport;
  }

  getPlanDocuments() {
    domainResources.map((domainResource) => {
      this.getDocuments = domainResource.GET_PLAN_DOCUMENTS;
      return;
    });

    return this.getAPIDomain() + this.getDocuments;
  }

  getPlanCoverageDocument() {
    domainResources.map((domainResource) => {
      this.downloadPlanDownload = domainResource.GET_DOWNLOAD_PLAN_DOCUMENT;
      return;
    });

    return this.getAPIDomain() + this.downloadPlanDownload;
  }

  //get procedure code
  getProcedureCodes() {
    domainResources.map((domainResource) => {
      this.healthProcedureCode = domainResource.GET_PROCEDURE_CODES;
      return;
    });

    return this.getAPIDomain() + this.healthProcedureCode;
  }

  //get doctor type suggestions
  getDoctorTypeSuggestions() {
    domainResources.map((domainResource) => {
      this.doctorTypeSuggetions = domainResource.GET_DOCTOR_TYPE_SUGGESTIONS;
      return;
    });

    return this.getAPIDomain() + this.doctorTypeSuggetions;
  }

  //get doctor name suggestions
  getDoctorNameSuggestions() {
    domainResources.map((domainResource) => {
      this.doctorNameSuggetions = domainResource.GET_DOCTOR_NAME_SUGGESTIONS;
      return;
    });

    return this.getAPIDomain() + this.doctorNameSuggetions;
  }

  //request doctor details
  getDoctorDetails() {
    domainResources.map((domainResource) => {
      this.doctorDetails = domainResource.GET_DOCTOR_DETAILS;
      return;
    });

    return this.getAPIDomain() + this.doctorDetails;
  }

  //request facility details
  getFacilityDetails() {
    domainResources.map((domainResource) => {
      this.facilityDetails = domainResource.GET_FACILITY_DETAILS;
      return;
    });

    return this.getAPIDomain() + this.facilityDetails;
  }
  //request facility address details
  getClaimsAddressDetails() {
    domainResources.map((domainResource) => {
      this.claimsAddressDetails = domainResource.GET_CLAIMS_ADDRESS;
      return;
    });

    return this.getAPIDomain() + this.claimsAddressDetails;
  }

  //request facility doctor details
  getFacilityAffiliatedDoctorsDetails() {
    domainResources.map((domainResource) => {
      this.facilityAffiliatedDoctorsDetails =
        domainResource.GET_AFFILIATED_DOCTORS_LIST;
      return;
    });

    return this.getAPIDomain() + this.facilityAffiliatedDoctorsDetails;
  }

  //get userTypes
  getUserTypes() {
    domainResources.map((domainResource) => {
      this.userTypes = domainResource.GET_USER_TYPES;
      return;
    });

    return this.getAPIDomain() + this.userTypes;
  }

  getComparedRequestId() {
    domainResources.map((domainResource) => {
      this.getComparedRequest = domainResource.GET_COMPARED_REQUEST_ID;
      return;
    });

    return this.getAPIDomain() + this.getComparedRequest;
  }

  getCompareClaimDetails() {
    domainResources.map((domainResource) => {
      this.getComparedClaimDetailsRequest =
        domainResource.GET_COMPARED_CLAIM_DETAILS;
      return;
    });

    return this.getAPIDomain() + this.getComparedClaimDetailsRequest;
  }

  getAllBrokers() {
    domainResources.map((domainResource) => {
      this.BrokersLists = domainResource.GET_ALL_BROKERS;
      return;
    });
    return this.getAPIDomain() + this.BrokersLists;
  }

  getPermissionsListsUserType() {
    domainResources.map((domainResource) => {
      this.PermissionGroupLists = domainResource.PERMISSIONS_LISTS_USERTYPE;
      return;
    });
    return this.getAPIDomain() + this.PermissionGroupLists;
  }

  //request for getting recent request price compare list
  getPriceCompareRecentSearchList() {
    domainResources.map((domainResource) => {
      this.getPriceCompareRecentRequestList =
        domainResource.GET_PRICE_COMPARE_RECENT_SEARCH_LIST;
      return;
    });

    return this.getAPIDomain() + this.getPriceCompareRecentRequestList;
  }

  //request for getting recent request price compare list based on login user
  getPriceCompareRecentSearchListLoginUser() {
    domainResources.map((domainResource) => {
      this.getPriceCompareRecentRequestListLoginUser =
        domainResource.GET_PRICE_COMPARE_RECENT_SEARCH_LIST_LOGIN_USER;
      return;
    });

    return this.getAPIDomain() + this.getPriceCompareRecentRequestListLoginUser;
  }

  //get Network/Tier Data for Price Compare
  getNetworkTierPriceCompareData() {
    domainResources.map((domainResource) => {
      this.getNetworkTierPriceCompareDataList =
        domainResource.GET_NETWORK_TIER_DATA;
      return;
    });

    return this.getAPIDomain() + this.getNetworkTierPriceCompareDataList;
  }

  //request for getting recent request id data
  getPriceCompareDetailsById() {
    domainResources.map((domainResource) => {
      this.getDetailsByRequestId =
        domainResource.GET_PRICE_COMPARE_DETAILS_BY_ID;
      return;
    });
    return this.getAPIDomain() + this.getDetailsByRequestId;
  }

  //delete recent request by requestId
  deleteRecentRequestById() {
    domainResources.map((domainResource) => {
      this.deletRequestById = domainResource.DELETE_RECENT_REQUEST_BY_ID;
      return;
    });
    return this.getAPIDomain() + this.deletRequestById;
  }

  //get document list for upload document
  getDocumentUploadList() {
    domainResources.map((domainResource) => {
      this.getAllDocumentList = domainResource.GET_DOCUMENT_UPLOADS;
      return;
    });
    return this.getAPIDomain() + this.getAllDocumentList;
  }

  //get documents detail API
  getDocumentsDetail() {
    domainResources.map((domainResource) => {
      this.getDocumentsDetails = domainResource.GET_DOCUMENT_DETAILS;
      return;
    });
    return this.getAPIDomain() + this.getDocumentsDetails;
  }

  //Download single document
  getDocumentsDownload() {
    domainResources.map((domainResource) => {
      this.getDocumentDownload = domainResource.GET_DOCUMENT_DOWNLOAD;
      return;
    });
    return this.getAPIDomain() + this.getDocumentDownload;
  }

  //Download zip document
  getAllDocumentsDownload() {
    domainResources.map((domainResource) => {
      this.getAllDocumentDownload = domainResource.GET_ALL_DOCUMENT_DOWNLOAD;
      return;
    });
    return this.getAPIDomain() + this.getAllDocumentDownload;
  }

  //Post form data for document upload
  postFormDataUploadDocument() {
    domainResources.map((domainResource) => {
      this.formDataUploadDocument =
        domainResource.POST_UPLOAD_DOCUMENT_FORM_DATA;
      return;
    });
    return this.getAPIDomain() + this.formDataUploadDocument;
  }

  //Post form data for document upload
  postFileDataUploadDocument() {
    domainResources.map((domainResource) => {
      this.fileDataUploadDocument =
        domainResource.POST_UPLOAD_DOCUMENT_FILE_DATA;
      return;
    });
    return this.getAPIDomain() + this.fileDataUploadDocument;
  }

  //get API for type values in upload documents
  getTypeValueUploadDocument() {
    domainResources.map((domainResource) => {
      this.typeValueUploadDocument = domainResource.GET_DOCUMENT_TYPE_LIST;
      return;
    });
    return this.getAPIDomain() + this.typeValueUploadDocument;
  }

  getSecurityQuestions() {
    domainResources.map((domainResource) => {
      this.SecurityQuestions = domainResource.GET_SECURITY_QUESTIONS;
      return;
    });
    return this.getAPIDomain() + this.SecurityQuestions;
  }

  getCreateAllUserTypesAPIResource() {
    domainResources.map((domainResource) => {
      this.createAllUserTypesAPIResource =
        domainResource.CREATE_ALL_USER_API_USER_TYPES;
      return;
    });
    return this.getAPIDomain() + this.createAllUserTypesAPIResource;
  }

  getSecurityQuestionsByUserID() {
    domainResources.map((domainResource) => {
      this.SecurityQuestionsUserID =
        domainResource.GET_SECURITY_QUESTIONS_BY_USERID;
      return;
    });
    return this.getAPIDomain() + this.SecurityQuestionsUserID;
  }

  validateSecurityQuestions() {
    domainResources.map((domainResource) => {
      this.ValidateSecurityQuestions =
        domainResource.VALIDATE_SECURITY_QUESTIONS;
      return;
    });
    return this.getAPIDomain() + this.ValidateSecurityQuestions;
  }

  getUserRegistrationDetails() {
    domainResources.map((domainResource) => {
      this.getUserRegistionDetails =
        domainResource.GET_USER_REGISTRATION_DETAILS;
      return;
    });
    return this.getAPIDomain() + this.getUserRegistionDetails;
  }

  getUserDetailsOnBoarding() {
    domainResources.map((domainResource) => {
      this.getUserDetails = domainResource.GET_USER_DETAILS_ONBOARDING;
      return;
    });
    return this.getAPIDomain() + this.getUserDetails;
  }

  postSecurityQuestions() {
    domainResources.map((domainResource) => {
      this.postSecQuestions = domainResource.POST_SECURITY_QUESTIONS;
      return;
    });
    return this.getAPIDomain() + this.postSecQuestions;
  }

  getUpdateAllUserAPIResource() {
    domainResources.map((domainResource) => {
      this.updateAllUserAPIResource =
        domainResource.UPDATE_All_USER_API_RESOURCE;
      return;
    });
    return this.getAPIDomain() + this.updateAllUserAPIResource;
  }

  getSendResetPasswordMail() {
    domainResources.map((domainResource) => {
      this.sendResetPasswordMail = domainResource.GET_SEND_RESETPASSWORD_MAIL;
      return;
    });
    return this.getAPIDomain() + this.sendResetPasswordMail;
  }

  getVerifyResetPasswordLink() {
    domainResources.map((domainResource) => {
      this.verifyResetPasswordLink =
        domainResource.GET_VERIFY_RESETPASSWORD_LINK;
      return;
    });
    return this.getAPIDomain() + this.verifyResetPasswordLink;
  }

  resendRegistrationEmail() {
    domainResources.map((domainResource) => {
      this.resendRegistrationEmailResources =
        domainResource.RESEND_REGISTRATION_EMAIL;
      return;
    });
    return this.getAPIDomain() + this.resendRegistrationEmailResources;
  }

  getAllReportList() {
    domainResources.map((domainResource) => {
      this.getAllReportListResource = domainResource.GET_ALL_REPORTS_LIST_DATA;
      return;
    });
    return this.getAPIDomain() + this.getAllReportListResource;
  }

  getReportsCategoryAndName() {
    domainResources.map((domainResource) => {
      this.getReportsCategoryAndNameResource =
        domainResource.GET_REPORTS_CATEGORY_AND_NAME;
      return;
    });
    return this.getAPIDomain() + this.getReportsCategoryAndNameResource;
  }

  getReportDynamicFields() {
    domainResources.map((domainResource) => {
      this.getReportDynamicFieldsResource =
        domainResource.GET_REPORTS_DYNAMIC_FIELDS;
      return;
    });
    return this.getAPIDomain() + this.getReportDynamicFieldsResource;
  }

  getViewMemberinformation() {
    domainResources.map((domainResource) => {
      this.getViewMemberinformationResource =
        domainResource.VIEW_MEMBER_INFORMATION;
      return;
    });
    return this.getAPIDomain() + this.getViewMemberinformationResource;
  }

  getViewMemberinformationV2() {
    domainResources.map((domainResource) => {
      this.getViewMemberinformationResourcev2 =
        domainResource.VIEW_MEMBER_INFORMATION_V2;
      return;
    });
    return this.getAPIDomain() + this.getViewMemberinformationResourcev2;
  }

  getDownloadReport() {
    domainResources.map((domainResource) => {
      this.getDownloadReportResource = domainResource.GET_REPORTS_DOWNLOADS;
      return;
    });
    return this.getAPIDomain() + this.getDownloadReportResource;
  }

  deletedSelectedReports() {
    domainResources.map((domainResource) => {
      this.getDeteletedReportsResult = domainResource.DELETE_SELECETED_REPORTS;
      return;
    });
    return this.getAPIDomain() + this.getDeteletedReportsResult;
  }

  generateReport() {
    domainResources.map((domainResource) => {
      this.generateReportResource = domainResource.GENERATE_REPORT;
      return;
    });
    return this.getAPIDomain() + this.generateReportResource;
  }

  sendReportsEmail() {
    domainResources.map((domainResource) => {
      this.getSendReportsEmail = domainResource.GET_SEND_REPORTS_EMAIL;
      return;
    });
    return this.getAPIDomain() + this.getSendReportsEmail;
  }

  getFacilityListResources() {
    domainResources.map((domainResource) => {
      this.getFacilityListsResource = domainResource.GET_FACILITY_LISTS;
      return;
    });
    return this.getAPIDomain() + this.getFacilityListsResource;
  }

  getDoctorsListResources() {
    domainResources.map((domainResource) => {
      this.getDoctorsListsResource = domainResource.GET_DOCTORS_LISTS;
      return;
    });
    return this.getAPIDomain() + this.getDoctorsListsResource;
  }

  getHippaPermissionsResources() {
    domainResources.map((domainResource) => {
      this.getHippaPermissionsResource = domainResource.GET_HIPPA_PERMISSIONS;
      return;
    });
    return this.getAPIDomain() + this.getHippaPermissionsResource;
  }
  getHippaPermissionsRights() {
    domainResources.map((domainResource) => {
      this.getHippaPermissionsRightsData =
        domainResource.GET_HIPPA_PERMISSIONS_RIGHTS;
      return;
    });
    return this.getAPIDomain() + this.getHippaPermissionsRightsData;
  }
  updateHippaPermissionsRights() {
    domainResources.map((domainResource) => {
      this.getHippaPermissionsRightsUpdates =
        domainResource.GET_HIPPA_PERMISSIONS_RIGHTS_UPDATES;
      return;
    });
    return this.getAPIDomain() + this.getHippaPermissionsRightsUpdates;
  }
  //get send receive message api
  getPublishedMessageResources() {
    domainResources.map((domainResource) => {
      this.getPublishedMessageResource = domainResource.PUBLISHED_MESSAGE;
      return;
    });
    return this.getAPIDomain() + this.getPublishedMessageResource;
  }

  searchClaimsIndependently() {
    return this.getAPIDomain() + domainResources[0].SEARCH_CLAIMS_INDEPENDTLY;
  }

  //search facility with different params
  searchFacilities() {
    return this.getAPIDomain() + domainResources[0].SEARCH_FACILITIES;
  }

  //search physicians with different params
  searchPhysicians() {
    return this.getAPIDomain() + domainResources[0].SEARCH_PHYSICIANS;
  }

  //search members with different params
  searchMembers() {
    return this.getAPIDomain() + domainResources[0].SEARCH_MEMBERS;
  }

  advanceMemberSearch() {
    return this.getAPIDomain() + domainResources[0].ADVANCE_MEMBER_SEARCH;
  }

  //update member user address
  updateMemberAddress() {
    return this.getAPIDomain() + domainResources[0].UPDATE_MEMBER_USER_ADDRESS;
  }

  enrollmentAddMemberAddress() {
    return (
      this.getAPIDomain() + domainResources[0].ENROLLMENT_ADD_MEMBER_ADDRESS
    );
  }

  enrollmentAddDependentAddress() {
    domainResources.map((domainResource) => {
      this.enrollmentAddDependentAddressDetails =
        domainResource.ENROLLMENT_ADD_DEPENDENT_ADDRESS;
      return;
    });
    return this.getAPIDomain() + this.enrollmentAddDependentAddressDetails;
  }

  //update dependent user address
  updateDependentAddress() {
    return (
      this.getAPIDomain() + domainResources[0].UPDATE_DEPENDENT_USER_ADDRESS
    );
  }

  deleteDocumentAttachment() {
    domainResources.map((domainResource) => {
      this.getDeteletedDocumnet = domainResource.DELETE_DOCUMENT_ATTACHMENT;
      return;
    });
    return this.getAPIDomain() + this.getDeteletedDocumnet;
  }

  postSendBulkMessage() {
    domainResources.map((domainResource) => {
      this.sendBulkMessage = domainResource.SEND_BULK_MESSAGE;
      return;
    });
    return this.getAPIDomain() + this.sendBulkMessage;
  }
  getFacilityTypeSuggestions() {
    domainResources.map((domainResource) => {
      this.getFacilityTypes = domainResource.GET_FACILITY_TYPES;
      return;
    });
    return this.getAPIDomain() + this.getFacilityTypes;
  }

  getFacilityNameSuggestions() {
    domainResources.map((domainResource) => {
      this.getFacilityNames = domainResource.GET_FACILITY_NAMES;
      return;
    });
    return this.getAPIDomain() + this.getFacilityNames;
  }
  //update member - to update member contact api
  updateMember() {
    return this.getAPIDomain() + domainResources[0].UPDATE_MEMBER;
  }

  //update dependent - to update member contact api
  updateDependent() {
    return this.getAPIDomain() + domainResources[0].UPDATE_DEPENDENT;
  }

  //get notification count api
  getNotificationcountapi() {
    domainResources.map((domainResource) => {
      this.getNotification = domainResource.NOTIFICATION_POPUP_COUNT;
      return;
    });
    return this.getAPIDomain() + this.getNotification;
  }

  getMemberCoveragePlanNetworks() {
    domainResources.map((domainResource) => {
      this.memberCoveragePlan = domainResource.MEMBER_COVERAGE_NETWORK;
      return;
    });
    return this.getAPIDomain() + this.memberCoveragePlan;
  }

  getCodeSetNames() {
    return this.getAPIDomain() + domainResources[0].GET_CODESET_NAMES;
  }

  //get send receive message api
  getSendReceiveMessage() {
    domainResources.map((domainResource) => {
      this.getReceivedMessages = domainResource.SEND_RECEIVE_MESSAGE;
      return;
    });
    return this.getAPIDomain() + this.getReceivedMessages;
  }

  //get type category list api
  getTypeCategoryList() {
    domainResources.map((domainResource) => {
      this.getTypeOptions = domainResource.GET_TYPE_CATEGORY_MESSAGE;
      return;
    });
    return this.getAPIDomain() + this.getTypeOptions;
  }

  getEventTypeOid() {
    domainResources.map((domainResource) => {
      this.getEventTypeOptions =
        domainResource.GET_EVENTTYPE_OID_PUBLISH_MESSAGE;
      return;
    });
    return this.getAPIDomain() + this.getEventTypeOptions;
  }

  getAllEnrollmentConfig() {
    domainResources.map((domainResource) => {
      this.allEmrollmentConfigList = domainResource.GET_ALL_ENROLLMENT_CONFIG;
      return;
    });
    return this.getAPIDomain() + this.allEmrollmentConfigList;
  }

  //Claims Documents List
  getClaimsDocumentList() {
    domainResources.map((domainResource) => {
      this.getAllClaimsDocumentList = domainResource.GET_CLAIMS_DOCUMENTS;
      return;
    });
    return this.getAPIDomain() + this.getAllClaimsDocumentList;
  }

  //mark message as READ
  postMarkMessageIsRead() {
    domainResources.map((domainResource) => {
      this.markMessageIsRead = domainResource.MARK_MESSAGE_ISREAD;
      return;
    });
    return this.getAPIDomain() + this.markMessageIsRead;
  }

  //get zaki point service codes
  getZakiPointProcedureCode() {
    return (
      this.getAPIDomain() + domainResources[0].GET_ZAKIPOINT_PROCEDURE_CODES
    );
  }

  dualCoverageApprove() {
    return (
      this.getAPIDomain() + domainResources[0].DUAL_COVERAGE_APPROVE_RESOURCE
    );
  }

  dualCoverageDenied() {
    return (
      this.getAPIDomain() + domainResources[0].DUAL_COVERAGE_DENIED_RESOURCE
    );
  }

  //get porvider registration configuration
  getProviderRegistrationConfiguration() {
    domainResources.map((domainResource) => {
      this.ProviderRegistrationConfiguration =
        domainResource.GET_PROVIDER_REGISTRATION_CONFIGURATION;
      return;
    });
    return this.getAPIDomain() + this.ProviderRegistrationConfiguration;
  }
  //porvider registration for doctor and facility
  DoctorFacilityProvider() {
    domainResources.map((domainResource) => {
      this.DoctorFacilityProviderRegister =
        domainResource.DOCTOR_FACILITY_PROVIDER_REGISTRATION;
      return;
    });
    return this.getAPIDomain() + this.DoctorFacilityProviderRegister;
  }

  //porvider registration for doctor and facility
  postCreateProviderWithApproval() {
    domainResources.map((domainResource) => {
      this.createProviderWithApprovalRequest =
        domainResource.NEW_PROVIDER_WITH_APPROVAL_REQUEST;
      return;
    });
    return this.getAPIDomain() + this.createProviderWithApprovalRequest;
  }

  getProviderApprovalListAPI() {
    domainResources.map((domainResource) => {
      this.providerListForApproval = domainResource.PROVIDER_APPROVAL_LIST;
      return;
    });
    return this.getAPIDomain() + this.providerListForApproval;
  }

  validateSlug() {
    return this.getAPIDomain() + domainResources[0].VALIDATE_SLUG;
  }

  getProviderUserDetails() {
    domainResources.map((domainResource) => {
      this.providerUserDetails = domainResource.PROVIDER_USER_DETAILS;
      return;
    });
    return this.getAPIDomain() + this.providerUserDetails;
  }

  postApproveAPICall() {
    domainResources.map((domainResource) => {
      this.providerUserApprovalDetails = domainResource.PROVIDER_APPROVAL_CALL;
      return;
    });
    return this.getAPIDomain() + this.providerUserApprovalDetails;
  }

  putDeniedAPICall() {
    domainResources.map((domainResource) => {
      this.providerUserDeniedDetails = domainResource.PROVIDER_DENIED_CALL;
      return;
    });
    return this.getAPIDomain() + this.providerUserDeniedDetails;
  }

  getEnrollmentRequestsListAPI() {
    //domainResources.map((domainResource) => {
    //this.providerListForApproval = domainResource.ENROLLMENT_REQUESTS_LIST;
    //return;
    //});
    //return this.getAPIDomain() + this.providerListForApproval;
    return this.getAPIDomain() + domainResources[0].ENROLLMENT_REQUESTS_LIST;
  }

  getRequestTypeForEnrollment() {
    domainResources.map((domainResource) => {
      this.requestTypeEnrollment = domainResource.REQUEST_TYPE_FOR_ENROLLMENT;
      return;
    });
    return this.getAPIDomain() + this.requestTypeEnrollment;
  }

  getRequestTypeForEnrollmentAffiliation() {
    domainResources.map((domainResource) => {
      this.requestTypeEnrollmentAffiliation =
        domainResource.REQUEST_TYPE_FOR_ENROLLMENT_AFFILIATION;
      return;
    });
    return this.getAPIDomain() + this.requestTypeEnrollmentAffiliation;
  }

  approveEnrollmentRequest() {
    return this.getAPIDomain() + domainResources[0].APPROVE_ENROLLMENT_REQUEST;
  }
  //get client email configuration
  getClientEmailConfiguration() {
    domainResources.map((domainResource) => {
      this.CLIENT_EMAIL_CONFIG = domainResource.CLIENT_EMAIL_CONFIG;
      return;
    });
    return this.getAPIDomain() + this.CLIENT_EMAIL_CONFIG;
  }
  getViewAffiliationConfiguration() {
    return this.getAPIDomain() + domainResources[0].DUAL_COVERAGE_AFFILIATION;
  }

  getUpdatedAffiliationConfiguration() {
    return (
      this.getAPIDomain() + domainResources[0].UPDATE_DUAL_COVERAGE_AFFILIATION
    );
  }

  getViewAffiliationConfigurationV1() {
    return (
      this.getAPIDomain() + domainResources[0].DUAL_COVERAGE_AFFILIATION_V1
    );
  }

  isApprovalRequestPendingForMemberResource() {
    return (
      this.getAPIDomain() +
      domainResources[0].IS_APPROVAL_REQUEST_PENDING_FOR_MEMBER
    );
  }

  dualCoverageValidateMemberInfoNewResources() {
    return (
      this.getAPIDomain() +
      domainResources[0].DUAL_COVERAGE_VALIDATE_MEMBER_INFO_NEW_RESOURCE
    );
  }

  dualCoverageUpdateUserSelfAffiliationResources() {
    return (
      this.getAPIDomain() +
      domainResources[0].DUAL_COVERAGE_UPDATE_USER_SELF_AFFILIATION_RESOURCE
    );
  }

  UpdateUserResource() {
    return this.getAPIDomain() + domainResources[0].UPDATE_USER_API_RESOURCE;
  }

  UpdateUserResourceWithoutApproval() {
    return (
      this.getAPIDomain() +
      domainResources[0].UPDATE_USER_API_RESOURCE_WITHOUT_APPROVAL
    );
  }

  updateHelpCenterDocuments() {
    return this.getAPIDomain() + domainResources[0].UPDATE_HELPCENTER_DOCUMENTS;
  }

  getEnumerationAuditLog() {
    return this.getAPIDomain() + domainResources[0].GET_ENUMERATION_AUDIT_LOG;
  }
  getEnumerationAuditLogDownload() {
    return (
      this.getAPIDomain() +
      domainResources[0].GET_ENUMERATION_AUDIT_LOG_DOWNLOAD
    );
  }

  resetDomainResources() {
    this.apiDomain = '';
    this.BLOBListResources = '';
    this.loginResource = '';
    this.memberSummaryResource = '';
    this.memberCoverageSummaryResource = '';
    this.memberextcoveragesummary = '';
    this.memberAccumulatorResource = '';
    this.memberCoverageAccumsResource = '';
    this.claimStatusSummaryReource = '';
    this.claimStatusSummaryByProductResource = '';
    this.spendingSummaryResource = '';
    this.claimsListResource = '';
    this.claimslistFamilyTabsResource = '';
    this.claimDetailsResource = '';
    this.coveredServicesCostResource = '';
    this.myProfileDetailsResource = '';
    this.accountDetailsResource = '';
    this.sendEmailResource = '';
    this.userListDetailsResources = '';
    this.searchBlockOfBusiness = '';
    this.logoutResource = '';
    this.userRolesResources = '';
    this.createUserAPIResource = '';
    this.createUserRoleAPIResource = '';
    this.updateUserRoleAPIResource = '';
    this.userIDCheckAPIResource = '';
    this.updateUserAPIResource = '';
    this.updateProviderSelfRegistration = '';
    this.getAdminConfig = '';
    this.putAdminConfig = '';
    this.postAdminConfig = '';
    this.putResetUser = '';
    this.postResetUser = '';
    this.putResetPwd = '';
    this.postResetPwd = '';
    this.deleteAdminConfig = '';
    this.getOtpGenerate = '';
    this.getOtpVerify = '';
    this.registeredMemberListResources = '';
    this.unregisteredMemberListResources = '';
    this.encryptionKey = '';
    this.getMember = '';
    this.getIdCard = '';
    this.getuserIdCard = '';
    this.EOB = '';
    this.GET_ECHO_EOB = '';
    this.contactInfo = '';
    this.searchContactInfo = '';
    this.page = '';
    this.pages = '';
    this.link = '';
    this.rules = '';
    this.links = '';
    this.searchLinks = '';
    this.postDocument = '';
    this.GET_DOCUMENT = '';
    this.medias = '';
    this.resource = '';
    this.searchResources = '';
    this.getAccumsData = '';
    this.helpDocuments = '';
    this.Products = '';
    this.Plans = '';
    this.appConfigs = '';
    this.appDefinations = '';
    this.customNetworkList = '';
    this.allNetworkList = '';
    this.BrokersLists = '';
    this.PermissionGroupLists = '';
    this.SecurityQuestions = '';
    this.createAllUserTypesAPIResource = '';
    this.SecurityQuestionsUserID = '';
    this.ValidateSecurityQuestions = '';
    this.getUserRegistionDetails = '';
    this.getUserDetails = '';
    this.postSecQuestions = '';
    this.updateAllUserAPIResource = '';
    this.sendResetPasswordMail = '';
    this.verifyResetPasswordLink = '';
    this.resendRegistrationEmailResources = '';
    this.getAllReportListResource = '';
    this.getReportsCategoryAndNameResource = '';
    this.getReportDynamicFieldsResource = '';
    this.generateReportResource = '';
    this.getViewMemberinformationResource = '';
    this.getViewMemberinformationResourcev2 = '';
    this.getFacilityListsResource = '';
    this.getDoctorsListsResource = '';
    this.getHippaPermissionsResource = '';
    this.getPublishedMessageResource = '';
    this.allEmrollmentConfigList = '';
    this.enrollmentAddDependentAddressDetails = '';
  }
}

export default new APIEndpoints();
